<template>
  <div class="tab-body">
    <el-row class="autoFlex" :gutter="10" v-if="popupLoading">
      <el-col :span="4">
        <el-card class="leftCard">
          <div slot="header" class="clearfix">
            <span>模块列表</span>
            <el-button @click="chgState" :icon="state==1?'el-icon-delete-solid':'el-icon-success'"    :type="state==2?'success':'danger'"  size="mini"
             ></el-button>
            <el-button @click="expandTree" class="expandBtn" type="primary" icon="el-icon-s-fold" size="mini"
              style="margin-left: 20px; float: right"></el-button>
          </div>
          <tree v-loading="treeLoading" ref="permissionTree" :items="permissionList" :defaultExpandAll="treeExpand"
            :defaultParent="0" @nodeClick="treeClick"></tree>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card class="rightCard">
          <div slot="header" class="clearfix">
            <el-button  v-has-permission-code-and="'004000200105'" size="mini" :type="Subflag == '模块' ? 'primary' : 'success'" icon="el-icon-plus" v-if="Subflag" :disabled="state==2"
              @click="toSave()" style="margin-left: 30px">
              添加<span>{{ Subflag }}</span>
            </el-button>
          </div>
          <!-- <div class="operator"></div> -->
          <div class="dataTable autoFlex">
            <qlh-table class="table" style="height: auto" :data="subJectsTable" stripe border height="auto"
              :excelProp="excelProp">
              <qlh-table-column prop="name" :label="`${Subflag}名`" min-width="130" :editable="false">
              </qlh-table-column>
              <qlh-table-column prop="days" :label="`${Subflag}天数`" min-width="90" :width="110" :editable="false">
              </qlh-table-column>

              <qlh-table-column prop="level" label="等级" width="80" :formatter="(row, column) => {
      return row.level == 1
        ? '简单'
        : row.level == 2
          ? '一般'
          : '困难'
        ;
    }
      "></qlh-table-column>
              <qlh-table-column label="操作" fixed="right" width="800" ignored :editable="false">
                <template slot-scope="scope">
                  <div class="dataTable-operator" v-if="scope.row.id != '10044'">
                    <el-button size="mini"  type="success"  v-has-permission-code-and="'004000200105'" v-if="scope.row.pid==0" @click="updCnt(scope.row)">更新cnt
                      </el-button>
                    <el-button   v-has-permission-code-and="'004000200105'" size="mini" type="primary" 
                      @click="toUpdate(scope.$index, scope.row)">修改
                    </el-button>
                    <el-button size="mini"   v-has-permission-code-and="'004000200105'" type="success" v-if="scope.row.pid == '10044'" @click="selectSub(scope.$index, scope.row)">还原
                    </el-button>
                    <el-button size="mini" v-else  v-has-permission-code-and="'004000200105'" type="danger" @click="remove(scope.$index, scope.row)">作废
                    </el-button>

                    <el-button size="mini"   type="warning" @click="toExam(scope.$index, scope.row)">试卷[{{
                        scope.row.exmcnt
                      }}]
                    </el-button>
                    <el-button  size="mini"   @click="toDoc(scope.$index, scope.row)">文档[{{ scope.row.doccnt
                      }}]
                    </el-button>
                    <el-button    size="mini" type="warning" @click="toVedio(scope.$index, scope.row)">视频[{{
      scope.row.vdocnt }}]
                    </el-button>
                    <el-button    size="mini"   @click="toNote(scope.$index, scope.row)">笔记[{{
      scope.row.notecnt }}]
                    </el-button>
                    <el-button    size="mini" type="warning" @click="toCode(scope.$index, scope.row)">资料[{{
      scope.row.codecnt }}]
                    </el-button>

                    <el-button size="mini" v-if="scope.row.pid =='10044'"  v-has-permission-code-and="'004000200115'" type="danger" @click="remove(scope.$index, scope.row)">删除
                    </el-button>
                    <el-button size="mini"   v-has-permission-code-and="'004000200105'" v-if="false && scope.row.pid != '10044'"
                      @click="toMove(scope.row, -1)">
                      上移
                    </el-button>
                    <span v-if="scope.row.pid != '10044'">
                      <el-button size="mini" v-has-permission-code-and="'004000200105'" v-if="false && !currentNode.children" @click="toMove(scope.row, 1)">下移
                      </el-button>
               
                      <el-button size="mini"   v-has-permission-code-and="'004000200105'"
                        v-else-if="false && currentNode.children && scope.row.sort < currentNode.children.length"
                        @click="toMove(scope.row, 1)">下移
                      </el-button>
                    </span>
                  </div>
                </template>
              </qlh-table-column>
            </qlh-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div>

      <!-- 选择科目 -->
      <el-dialog :title="'还原节点到选中的模块 ~ '" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
        
          <el-select v-model="sbid" placeholder="请选择">
            <el-option v-for="item in allModel" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
       
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"   v-has-permission-code-and="'004000200105'" v-show="sbid!='请选模块'" @click="comfirmSub">选定模块</el-button>
        </span>
      </el-dialog>

    </div>
    <edit ref="edit"></edit>
    <show ref="show"></show>
  </div>
</template>
<script>

import edit from "./edit.vue";
import show from "./show.vue";
import tree from "@/components/tree/tree.vue";
import api from "@/api/edu/subject/subject.js";
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
import MyCom from "@/components/myCom2/myCom.vue";
import { log } from 'console';

export default {
  name: "course",
  components: {
    MyCom,
    tree,
    edit,
    show,
    qlhTable,
    qlhTableColumn,
  },
  data() {
    return {
      Subflag: "模块",
      selectNodeId: [],

      sbid: "请选模块", //科目id
      dialogVisible: false, //科目弹框开关
      allModel: [],
      toResoreNode: null,   //准备还原的节点

      state:1,

      popupLoading: true,
      treeLoading: false,
      treeRef: "permissionTree",
      treeExpand: false,
      permissionList: [],
      currentNode: {},
      subJectsTable: [],
      tableLoading: true,
      editParameter: {},
      excelProp: {
        excelName: "科目信息",
        sheetname: "科目信息",
      },
      clickedSubID: "",
    };
  },
  methods: {
    updCnt(row){

      console.log(row)
      api.updtCnt({id:row.id},res=>{
        this.$utils.msg.success("更新成功");
        this.list();
      }, err => {
          this.$utils.msg.warning("更新失败");
       })

    },
    chgState(){
      if(this.state == 1){
        this.state = 2
      }else{
        this.state = 1
      }
      this.list();

    },
    // 选择科目
    selectSub(index, row) {
      this.toResoreNode = row
      this.dialogVisible = true

      api.list({allMd:"allMd"},res=>{
        this.allModel= res.data
      })

    },comfirmSub(){
           
        this.$utils.confirm.warning(
          "提示还原【" + this.toResoreNode.name + "】",
          "确定还原本科目到新模块吗？",
          () => {
            api.update(
              { id:this.toResoreNode.id,pid: this.sbid ,days: this.toResoreNode.days,state:1  },
              (response) => {
                this.$utils.msg.success(response.msg);
                    this.list()
                    this.dialogVisible = false
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
              }
            );
          }
        );
    },

    toMove(row, flag) {
 
      api.move({ sid: row.id, flag: flag }, (res) => {
        if (res.msg == "操作成功") {
          //加载新的sort
          this.list()
        }
        this.$utils.msg.success(res.msg);
      })

    },

    //获取数据
    list(callback) {
      this.treeLoading = true;
      api.listWithZycnt({state:this.state}, (response) => {
        this.permissionList = response.data;
        this.treeLoading = false;
        this.freshTable();

        if (callback) {
          callback()
        }
      });
    },
    expandTree() {
      this.treeExpand = !this.treeExpand;
      //控制el-tree展开收起
      for (
        var i = 0;
        i < this.$refs.permissionTree.getTree().store._getAllNodes().length;
        i++
      ) {
        this.$refs.permissionTree.getTree().store._getAllNodes()[
          i
        ].expanded = this.treeExpand;
      }
    },
    //点击部门
    treeClick(data) {
      // 判断是否为一级目录

      if (data.id.length < 6) {      
        if (this.selectNodeId.includes(data.id)) {
          this.selectNodeId = this.selectNodeId.filter((item) => {
            return item !== data.id;
          });
          this.Subflag = "模块";
          this.currentNode = {};
          this.clickedSubID = data.id
          this.freshTable();
        } else {
          this.selectNodeId.push(data.id);
          this.Subflag = "子科目";
          this.currentNode  = data;
          // console.log(this.goBackData);
          this.clickedSubID = data.id
          this.freshTable();
          this.selectNodeId = this.selectNodeId.filter((item) => {
            return item === data.id;
          });
        }
      } else {
        this.goBack = true;
        this.Subflag = false;
        this.currentNode = data;
        this.freshTable();
      }
    },
    freshTable() {
      this.tableLoading = true;
      this.subJectsTable = [];
      if (this.currentNode.id) {
                if (this.clickedSubID) {
                    api.listWithZycnt({state:this.state, pid: this.clickedSubID }, (response) => {
                        this.subJectsTable = response.data;
                        this.$forceUpdate()
                        this.treeLoading = false;
                    });
                } else {
                    this.subJectsTable = this.permissionList
                }
            } else {
                this.subJectsTable = this.permissionList
            }
            this.tableLoading = false;
 
    }, updateSorts() {

      if (this.subJectsTable && this.subJectsTable.length > 0) {
        //校验前面的顺序
        this.subJectsTable.forEach((v, i) => {
          if (v.sort != (i + 1)) {
            //需要更新：执行后端更新
            //api.update({ id: v.id, sort: (i + 1) }, res => { })
            // 前端更新
            v.sort = (i + 1)
          }
        })
        return this.subJectsTable.length;
      }
      return 1;

    },
    //去添加
    toSave() {

      //计算新增的sort
      let max = this.updateSorts()

      let parameter = {
        pid: this.currentNode.id != undefined ? this.currentNode.id : 0,
        level: this.currentNode.level ? this.currentNode.level : 0,
        code: this.currentNode.code,
        maxSort: max
      };
      
      this.$refs.edit.open(parameter, "添加");
    },
    //去编辑
    toUpdate(index, row) {
      let parameter = {
        id: row.id,
      };
      this.$refs.edit.open(parameter, this.Subflag + "-[" + row.name + "]-修改");
    },
    toExam(index, row) {
      let parameter = {
        id: row.id,
        type: 9
      };
      this.$refs.show.open(parameter, this.Subflag + "-[" + row.name + "]-试题资源");
    },
    toDoc(index, row) {
      let parameter = {
        id: row.id,
        type: 1 

      };
      this.$refs.show.open(parameter, this.Subflag + "-[" + row.name + "]-文档资源");
    },
    toVedio(index, row) {
      let parameter = {
        id: row.id,
        type: 2 
      };
      this.$refs.show.open(parameter, this.Subflag + "-[" + row.name + "]-视频资源");
    },  toNote(index, row) {
      let parameter = {
        id: row.id,
        type: 3 
      };
      this.$refs.show.open(parameter, this.Subflag + "-[" + row.name + "]-课堂笔记");
    },  toCode(index, row) {
      let parameter = {
        id: row.id,
        type: 4 
      };
      this.$refs.show.open(parameter, this.Subflag + "-[" + row.name + "]-资料下载");
    },


    //删除
    remove(index, row) {

      let parameter = {
        id: row.id,
      };

      if (row.pid == '10044') {
        console.log("删除10044    ")

        this.$utils.confirm.warning(
          "提示删除【" + row.name + "】",
          "确定删除本科目吗？",
          () => {
            api.remove(
              parameter,
              (response) => {
                this.$utils.msg.success(response.msg);
                this.list();
              },
              (response) => {
                this.$utils.msg.warning(response.msg);
              }
            );
          }
        );
      } else {

        this.$utils.confirm.warning(
          "提示作废【" + row.name + "】",
          "不会物理删除，确定移除本科目吗？",
          () => {
            api.toDisble(
              parameter,
              (response) => {
                this.$utils.msg.success(response.msg);

                this.list(this.updateSorts);

              },
              (response) => {
                this.$utils.msg.warning(response.msg);
              }
            );
          }
        );
      }

    },
  },

  mounted() {
    this.list();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";

.dataTable-operator{
  justify-content: left !important;
}

</style>
